import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  type_pay: 0,
};

export const name = "typepay";

const slice = createSlice({
  name,
  initialState,
  reducers: {
    setTypePay: (state, action) => {
      state.type_pay = action.payload;
    },
    reset: (state) => {
      state.type_pay = 0;
    }
  },
});

export const { actions, reducer } = slice;

export const getTypePay = (state) => state.typepay.type_pay;